import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { InputComponent } from '../../shared/input/input.component';
import { AlertService } from '../../../services/shared/alert.service';
import { VerifyOtp } from '../../../models/adminmanagement/AdminUser';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import { AdminManagementService } from '../../../services/adminmanagement/adminmanagement.service';
import { ConstantValues } from '../../../common/constant-values';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.css'
})
export class OtpComponent implements OnInit, OnDestroy {
  defaultCountDown: number = 300; // Default to 5 minutes in seconds
  countdown: number = this.defaultCountDown;  
  interval: any;
  maskedEmail: string = '';
  otpDto = new VerifyOtp();
  isLoading = false;
  isResentLoading = false;
  isResendEnabled: boolean = false;
  resentRequestedCount: number = 0;
  displayMsg: string = '';

  @ViewChildren(InputComponent) inputComponents!: QueryList<InputComponent>;

  constructor(private router: Router, private adminService: AdminManagementService,
    private alertService: AlertService, private errorHandler: ErrorHandlerService) { }

  ngOnInit(): void {
    var userObj = localStorage.getItem(ConstantValues.LoginUserEmail);
    if (userObj) {
      this.otpDto.Email = userObj;
      this.maskedEmail = this.getMaskedEmail(this.otpDto.Email);
      // Check if there's a stored countdown value
      const storedCountdown = localStorage.getItem('otp-countdown');
      if (storedCountdown) {
        this.countdown = parseInt(storedCountdown);
      }
      this.startCountdown();
    } else {
      this.router.navigate(['/login']);
    }
  }

  getMaskedEmail(email: string): string {
    const emailParts = email.split('@');
    const localPart = emailParts[0];
    const domainPart = emailParts[1];

    const maskedLocalPart = localPart.slice(0, 2) + '****' + localPart.slice(-2);
    return maskedLocalPart + '@' + domainPart;
  }

  startCountdown() {
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        localStorage.setItem('otp-countdown', this.countdown.toString());  // Store remaining time in localStorage
      } else {
        clearInterval(this.interval);
        this.isResendEnabled = true;
      }
    }, 1000);
  }

  // Format countdown as minutes and seconds
  getFormattedCountdown(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes}m ${seconds < 10 ? '0' + seconds : seconds}s`;
  }

  backToLogin() {
    this.router.navigate(['/login']);
  }

  resendOtp() {
    var model = {
      Email: this.otpDto.Email
    }
    this.isResentLoading = true;

    this.adminService.resendOtp(model).subscribe(res => {
      this.isResentLoading = false;
      if (res.StatusCode === '000') {
        this.displayMsg = 'We sent you otp code on your email.';

        this.resentRequestedCount++;
        this.otpDto.AuthenticatorCode = '';

         this.isResendEnabled = false;
        this.countdown = this.defaultCountDown; // Reset the countdown
        localStorage.setItem('otp-countdown', this.countdown.toString()); // Reset countdown in localStorage
        this.startCountdown(); // Restart countdown

        setTimeout(() => {
          this.displayMsg = '';
        }, 2000)
      } 
      // else if (res.StatusCode === ConstantValues.HASH_MISMATCH_ERROR) {
      //   this.alertService.HashMismatchError();
      // } 
      else {
        this.alertService.showError(res.Message);
      }
    }, (err: HttpErrorResponse) => {
      this.isResentLoading = false;
      this.alertService.showError(this.errorHandler.handleError(err));
    });
  }

  twoFactorVerify(event: { page: string, form?: NgForm }) {
    if (event.form?.valid) {
      this.isLoading = true;
      this.adminService.VerifyOtp(this.otpDto).subscribe(res => {
        this.isLoading = false;
        if (res.StatusCode === '000') {
          localStorage.setItem(ConstantValues.TokenKey, res.Result?.AccessToken);
          localStorage.setItem(ConstantValues.RefreshTokenKey, res.Result?.RefreshToken)
          this.router.navigate(['dashboard']);
        } else if (res.StatusCode === '619') {
          this.alertService.Error(res.Message);
        } else if (res.StatusCode === ConstantValues.HASH_MISMATCH_ERROR) {
          this.alertService.HashMismatchError();
        } else {
          this.alertService.showError(res.Message).then(result => {
            if (result.isConfirmed)
              this.twoFactorVerify(event);
          });
        }
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;

        if (err.status !== 401) {
          this.alertService.showError(this.errorHandler.handleError(err)).then(result => {
            if (result.isConfirmed)
              this.twoFactorVerify(event);
          });
        } else {
          this.alertService.Error('Your session has expired. Please log in again.')
            .then(() => { this.router.navigate(['/login']); });
        }
      });
    } else {
      this.markAllInputsAsTouched();
    }
  }

  markAllInputsAsTouched(): void {
    this.inputComponents.forEach((input) => {
      input.markAsTouched();
    });
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    // Clear the countdown from localStorage when the component is destroyed
    localStorage.removeItem('otp-countdown');
  }
}
